import { createContext } from "react";

const CommentsContext = createContext();

export default CommentsContext;
